import React, { useContext, useEffect, useState } from 'react';
import styles from 'routes/adminMobile/pages/AdminMobileOrderDetail.module.css';
import { useLocation } from 'react-router-dom';
import { mainBgColor, mainBodyHeight, mainPadd, pageCommonPadd, pagePaddTopH } from '../constraints/AdminConst';
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import AdminMobileMoveBackBtn from 'routes/adminMobile/components/common/AdminMobileMoveBackBtn';
import AdminMobileOrderDetailComp from 'routes/adminMobile/components/AdminMobileOrderDetailComp';
import AdminMobileOrderStorePhoneNo from '../components/AdminMobileOrderStorePhoneNo';
import Dummy from 'components/Dummy';
import { BrowserDetectContext } from 'providers/BrowserEventProvider';

const AdminMobileOrderDetail = () => {
    const location = useLocation();
    const [orderData, setOrderData] = useState(null);
    const {isMobile} = useContext(BrowserDetectContext);

    useEffect(() => {
        if (location.state && location.state.orderData) {
            const receivedOrderData = location.state.orderData;
            
            setOrderData(receivedOrderData);
        } else {
            
        }
    }, [location.state]);

    return (
        <div style={{paddingTop: pagePaddTopH}}>
            <Container padding={pageCommonPadd} height={mainBodyHeight} backgroundColor={mainBgColor}>
                <VerticalFlex backgroundColor={mainBgColor}>
                    <FlexChild alignItems="flex-start" padding={mainPadd} backgroundColor={mainBgColor}>
                        <AdminMobileOrderDetailComp orderData={orderData} />
                        <Dummy height={"30px"} />
                    </FlexChild>
                    <FlexChild height={"initial"}>
                        <AdminMobileOrderStorePhoneNo orderData={orderData} />
                    </FlexChild>
                </VerticalFlex>
                <AdminMobileMoveBackBtn />
            </Container>
        </div>
    );
};

export default AdminMobileOrderDetail;